// Copyright (c) Bentley Systems
import { DawComponent } from "./daw-component";

export const DawComponentRoutePaths = {
  [DawComponent.DAW_COMPONENT_GENERAL_PROJECTS]: "/projects",
  [DawComponent.DAW_COMPONENT_SUBSCRIBED_PROJECTS]: "/subscribedProjects",
  [DawComponent.DAW_COMPONENT_SUBSCRIBED_ORGANIZATIONS]:
    "/subscribedOrganizations",
  [DawComponent.DAW_COMPONENT_LINKAGE_ATTRIBUTE_FORM]: "/linkageAttribute",
  [DawComponent.DAW_COMPONENT_EXTERNAL_VIEWS]: "/externalViews",
  [DawComponent.DAW_COMPONENT_CREDENTIAL_LIST]: "/credentialsList",
  [DawComponent.DAW_COMPONENT_MANAGE_ACCESS_ROLES_ASSIGNMENT_FORM]: "/manageAccessRolesAssignment",
  [DawComponent.DAW_COMPONENT_API_TESTING]: "/testing",
  [DawComponent.DAW_COMPONENT_ON_PREM_ROUTING]: "/onPremRouting",
  [DawComponent.DAW_COMPONENT_ON_PREM_TELEMETRY]: "/onPremTelemetry",
};
